import React, { useContext, useMemo } from 'react'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import LocationFloatingPanel from '../LocationSearchFloatingPanel/LocationFloatingPanel'
import SearchFormField from '../../SearchFormField/SearchFormField'
import CruiseLinesSearchList from 'components/Cruises/SearchPage/CruiseLines/CruiseLinesSearchList'
import { CRUISE_ARRIVAL_PLACE_SEARCH_PLACEHOLDER_LABEL, CRUISE_DESTINATION_SEARCH_TYPES, CRUISE_LOCATION_SEARCH_TYPEAHEAD_TYPES, SEARCH_DEPARTURE_PORTS } from 'constants/cruise'
import useToggle from 'hooks/useToggle'
import SearchFloatingPanel from '../SearchFloatingPanel/SearchFloatingPanel'
import CruiseWhenList from 'components/Cruises/SearchPage/CruiseWhenFilter/CruiseWhenList'
import { useAppSelector } from 'hooks/reduxHooks'
import Group from 'components/Luxkit/Group'
import CruiseWhenField from 'components/Cruises/SearchPage/CruiseWhenFilter/CruiseWhenField'

function CruisesTabContent() {
  const [isLocationModalOpen, toggleIsLocationModalOpen] = useToggle(false)
  const [isDepartureModalOpen, toggleIsDepartureModalOpen] = useToggle(false)
  const [isSearchWhenModalOpen, toggleIsSearchWhenModalOpen] = useToggle(false)
  const [isCruiseLineModalOpen, toggleIsCruiseLineModalOpen] = useToggle(false)

  const {
    searchItem,
    secondarySearchItem,
    cruiseLines: searchCruiseLines,
  } = useContext(GlobalSearchStateContext)
  const cruiseLines = useAppSelector(state => state.cruise.cruiseLines)

  const cruiseLineInputValue = useMemo(() => {
    const cruiseLineNames = cruiseLines
      .filter(({ code }) => searchCruiseLines?.includes(code))
      .map(({ name }) => name)

    const [firstName] = cruiseLineNames
    const more = cruiseLineNames.length > 1 ? `+${cruiseLineNames.length - 1}` : ''
    return firstName && `${firstName} ${more}`
  }, [searchCruiseLines, cruiseLines])

  return (
    <>
      <Group direction="vertical" gap={16}>

        <SearchFormField
          label="Destinations"
          placeholder="All destinations"
          value={searchItem?.format.mainText}
          onClick={toggleIsLocationModalOpen}
        />

        <SearchFormField
          label="Departure port"
          placeholder="All departure ports"
          value={secondarySearchItem?.format.mainText}
          onClick={toggleIsDepartureModalOpen}
        />

        <SearchFormField
          label="Cruise lines"
          placeholder="All cruise lines"
          value={cruiseLineInputValue}
          onClick={toggleIsCruiseLineModalOpen}
        />

        <CruiseWhenField
          onClick={toggleIsSearchWhenModalOpen}
        />
      </Group>

      {/* overlays */}
      <LocationFloatingPanel
        confirmButtonDisabled
        isOpen={isLocationModalOpen}
        onClose={toggleIsLocationModalOpen}
        onGoBack={toggleIsLocationModalOpen}
        onConfirm={toggleIsLocationModalOpen}
        searchTypes={CRUISE_DESTINATION_SEARCH_TYPES}
        typeaheadTypes={CRUISE_LOCATION_SEARCH_TYPEAHEAD_TYPES}
        placeholder={CRUISE_ARRIVAL_PLACE_SEARCH_PLACEHOLDER_LABEL}
      />

      <LocationFloatingPanel
        confirmButtonDisabled
        isOpen={isDepartureModalOpen}
        onClose={toggleIsDepartureModalOpen}
        onGoBack={toggleIsDepartureModalOpen}
        onConfirm={toggleIsDepartureModalOpen}
        searchTypes={CRUISE_DESTINATION_SEARCH_TYPES}
        typeaheadTypes={CRUISE_LOCATION_SEARCH_TYPEAHEAD_TYPES}
        title="Departure ports"
        isSecondaryLocation
        placeholder="All departure ports"
        popularPlaces={SEARCH_DEPARTURE_PORTS}

      />

      <SearchFloatingPanel
        title="Explore by featured cruise lines"
        isOpen={isCruiseLineModalOpen}
        onClose={toggleIsCruiseLineModalOpen}
        onGoBack={toggleIsCruiseLineModalOpen}
      >
        <CruiseLinesSearchList onSelect={toggleIsCruiseLineModalOpen} />
      </SearchFloatingPanel>

      <SearchFloatingPanel
        title="When do you want to go?"
        isOpen={isSearchWhenModalOpen}
        onClose={toggleIsSearchWhenModalOpen}
        onGoBack={toggleIsSearchWhenModalOpen}
      >
        <CruiseWhenList onSelect={toggleIsSearchWhenModalOpen} />
      </SearchFloatingPanel>
    </>
  )
}

export default CruisesTabContent
